import { render, staticRenderFns } from "./TekChild.vue?vue&type=template&id=2c48ed1e"
import script from "./TekChild.vue?vue&type=script&lang=js"
export * from "./TekChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports